jQuery(document).ready(function($){
  const proxy = {
    centerPadding: 30
  };
  
  const handleKeypressADA = function() {
    const keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') return;
    $(this).trigger('click');
  };
  
   if ( $('.split-block__ticker').length ) {
    let tickerModalOpen = false;
    let tickerCloseFunction = (callback) => {
      callback();
    };
    $('.split-block__ticker').each(function(){
      const speed = $(this).attr('data-speed');
      const inner = $(this).find('.split-block__ticker-inner');
      const strip = $(this).find('.split-block__ticker-inner__strip');
      const type = $(this).hasClass('top') ? 'top' : 'bottom';
      let multiples = 1;
      let dirAdd = type == 'bottom' ? '-=' : '+=';
  
      do {
        const clone = strip.clone(false);
        gsap.set(clone, {
          x: dirAdd + ( ( strip.outerWidth() * multiples ) )
        });
  
        $(inner).append(clone);
        multiples++;
      } while ( multiples * $(strip).outerWidth() < $(window).innerWidth() * 2 );
  
      const scrollTL = gsap.timeline({
        repeat: -1
      });
  
      scrollTL.to(inner.find('.split-block__ticker-inner__strip'), {
        x: type === 'top' ? '-=' + $(strip).outerWidth() : '+=' + $(strip).outerWidth(),
        duration: () => {
          return $(strip).outerWidth() / speed;
        },
        ease: 'none'
      });
  
      if ( $(this).find('.split-block__ticker-triggeraa').length ) {
        const modalArea = $('.wmg-fixed-modal-elements');
  
        $(this).find('.split-block__ticker-trigger').each(function(){
          if ( $(this).is('button') ) {
            const modal = $(this).next();
            const parent = $(this).parent();
            $(this).on('click', function(){
              if ( !tickerModalOpen ) {
                tickerModalOpen = true;
                scrollTL.pause();
                modalArea.addClass(type);
                modalArea.append(modal);
                gsap.to(modal, {
                  opacity: 1,
                });
  
                tickerCloseFunction = (callback) => {
                  gsap.to(modal, {
                    opacity: 0,
                    onComplete: function(){
                      parent.append(modal);
                      scrollTL.play();
                      modalArea.removeClass(type);
                      tickerModalOpen = false;
                      callback();
                    },
                    duration: 0.8
                  });
                };
  
                modal.on('click', function(e){
                  console.log(e.target);
                  if ( e.target === modal.get(0) || $(e.target).hasClass('split-block__ticker-modal__dismiss') || $(e.target).closest('.split-block__ticker-modal__dismiss').length === 1 ) {
                    tickerCloseFunction(() => {});
                  }
                });
              } else {
                tickerCloseFunction(() => {
                  tickerModalOpen = true;
                  scrollTL.pause();
                  modalArea.addClass(type);
                  modalArea.append(modal);
                  gsap.to(modal, {
                    opacity: 1,
                  });
  
                  tickerCloseFunction = (callback) => {
                    gsap.to(modal, {
                      opacity: 0,
                      onComplete: function(){
                        parent.append(modal);
                        scrollTL.play();
                        modalArea.removeClass(type);
                        tickerModalOpen = false;
                        callback();
                      },
                      duration: 0.8
                    });
                  };
  
                  modal.on('click', function(e){
                    if ( e.target === modal.get(0) ) {
                      tickerCloseFunction(() => {});
                    }
                  });
                });
              }
            }).on('keypress', handleKeypressADA);
          }
        });
      }
    });
  } 

  jQuery('.custom-video-slider').slick({
    centerMode: true,
    centerPadding: '21%',
    arrows: true,
    prevArrow: '<button type="button" class="slick-gallery-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-gallery-arrow slick-next"><span class="screen-reader-text">Previous</span></button>',
    responsive:[
      {
        breakpoint: 767,
        settings: {
          centerPadding: '5%'
        }
      }
    ]
  }); 
  if(window.innerWidth > 880){
    $('.tt-item-img-inner-wraper:not(.slick-initialized)').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1
    });
  }
  
  $('.tt-quantity a').click(function(){
    setTimeout(function(){
        $('.tt-item-img-wraper .slick-prev').click();
    },50)    
  });
  jQuery('#featuregrid__item--earlyaccess,#featuregrid__item--earlyaccessMedia').hover(
    function() {
      $('#featuregrid__item--earlyaccess,#featuregrid__item--earlyaccessMedia').addClass('state-hover');
    }, function() {
      $('#featuregrid__item--earlyaccess,#featuregrid__item--earlyaccessMedia').removeClass('state-hover');
    }
  )

  
  jQuery('#auto-v-modal').click();
  
})
  